module.exports = __webpack_public_path__ + "static/bg-catalolyst.0fd38583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-catalolyst.jpg
// module id = 436
// module chunks = 35783957827783 172322841747965